module.exports = __webpack_public_path__ + "static/media/LINK.2ef73684.svg";